/**
 * Initial state factory for the "securityAuth" (twoFactorAuth) Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. `qrCodeDataUrl` and `secretKey`
 * hold the setup data generated for enrolling in 2FA, and `message` carries
 * the latest status/error message for the 2FA flow.
 */
export default () => ({
  isTwoFaEnabled: false,
  qrCodeDataUrl: "",
  secretKey: "",
  isLoading: false,
  message: "",
});
